import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTwitter32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTwitter32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M24.85 11.983c.013.174.013.347.013.522 0 5.34-4.334 11.495-12.259 11.495v-.003A12.8 12.8 0 0 1 6 22.186q.511.057 1.025.058a9.03 9.03 0 0 0 5.351-1.733c-1.843-.032-3.46-1.16-4.025-2.805a4.6 4.6 0 0 0 1.945-.07c-2.01-.38-3.456-2.036-3.456-3.96v-.05c.6.312 1.27.486 1.956.505-1.893-1.186-2.477-3.548-1.334-5.394 2.188 2.524 5.415 4.058 8.88 4.22-.347-1.403.127-2.873 1.246-3.86 1.735-1.529 4.465-1.45 6.096.176a9 9 0 0 0 2.736-.98 4.1 4.1 0 0 1-1.894 2.234A9 9 0 0 0 27 9.89a8.5 8.5 0 0 1-2.15 2.093"
            />
        </svg>
    );
}
export default memo(IconTwitter32);
